export default __webpack_public_path__ + "202abcd20cfaa12759dbd537177760f8.png";